// extracted by mini-css-extract-plugin
module.exports = {"shippingAddress":"ShippingAddress_shippingAddress__it1-s","subHeading":"ShippingAddress_subHeading__r2bh6"};